export const EXPERTISE_SERVICES = [
  {
    num: '01',
    label: 'Kundli Reading',
    chip: 'Kundli',
    desc: 'A complete analysis of your birth chart — the cosmic blueprint that reveals your personality, life patterns, and the planetary forces shaping your entire destiny.',
    features: ['Lagna & Navamsa chart analysis', 'Planetary strengths & dignities', 'Life-period (Dasha) predictions'],
    circle: { cx: 12, cy: 12, r: 4 },
    paths: ['M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41'],
  },
  {
    num: '02',
    label: 'Career Guidance',
    chip: 'Career',
    desc: 'Decode the planetary map of your professional life — know the right time for career moves, business ventures, and financial decisions that are cosmically aligned.',
    features: ['10th house & Artha yoga analysis', 'Auspicious muhurtas for decisions', 'Saturn, Jupiter & Rahu transit reading'],
    rect: { x: 2, y: 7, width: 20, height: 14, rx: 2 },
    paths: ['M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16'],
  },
  {
    num: '03',
    label: 'Marriage',
    chip: 'Marriage',
    desc: 'Vedic compatibility science that transcends sun signs — examining guna milan, mangal dosha, and the karmic bond between two souls seeking sacred union.',
    features: ['Guna Milan (36-point matching)', 'Mangal dosha assessment', 'Navamsa & 7th house synastry'],
    paths: ['M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z'],
  },
  {
    num: '04',
    label: 'Health Issues',
    chip: 'Health',
    desc: 'Planetary influences on physical and mental wellbeing — with targeted Vedic remedies to restore balance, strengthen vitality, and guide crucial medical timing.',
    features: ['6th house health configuration', 'Planetary remedy prescriptions', 'Timing for medical & surgical decisions'],
    paths: ['M22 12h-4l-3 9L9 3l-3 9H2'],
  },
  {
    num: '05',
    label: 'Vastu Shastra',
    chip: 'Vastu',
    desc: 'Sacred architectural science that harmonizes your living and working spaces with cosmic energies — attracting prosperity, peace, and divine protective forces.',
    features: ['Home & office spatial analysis', 'Directional Vastu corrections', 'Five-element balance remedies'],
    paths: ['M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'],
    polylines: [[9, 22, 9, 12, 15, 12, 15, 22]],
  },
  {
    num: '06',
    label: 'Palmistry',
    chip: 'Palmistry',
    desc: "The ancient art of reading destiny in the hand's lines, mounts, and marks. Each contour is a living record of accumulated karma and the soul's latent potential.",
    features: ['Life, heart & fate line reading', 'Mount interpretation & planets', 'Timing major life events by hand'],
    paths: [
      'M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v0',
      'M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2',
      'M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8',
      'M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15',
    ],
  },
  {
    num: '07',
    label: 'Gemstones',
    chip: 'Gems',
    desc: 'Precisely prescribed gemstones that amplify benefic planetary energies and counteract malefic influences — each stone a cosmic conduit for healing and protection.',
    features: ['Birth chart gem correlation', 'Quality, carat & metal guidance', 'Wearing ritual & muhurta timing'],
    paths: ['M6 3h12l4 6-10 13L2 9Z', 'M11 3 8 9l4 13 4-13-3-6', 'M2 9h20'],
  },
  {
    num: '08',
    label: 'Face Reading',
    chip: 'Face',
    desc: "Samudrik Shastra — the Vedic science of physiognomy — reads the soul's journey through the proportions, features, and sacred marks of the face.",
    features: ['Facial feature & zone analysis', 'Mole & birth mark significance', 'Character & fortune assessment'],
    circle: { cx: 12, cy: 8, r: 5 },
    paths: ['M20 21a8 8 0 1 0-16 0'],
  },
]
